module.exports = __webpack_public_path__ + "static/media/card-profile6-square.1f1f4900.jpg";